<template>
  <div>
    <MainPage v-if="loaded" :open-article="true" :shuffle-articles="true">
      <ArticleSearchOnPage :genres="genres" :schools="schools"/>
    </MainPage>
  </div>
</template>

<script>
import MainPage from "./main.page";

export default {
  name: "JuryPage",
  components: { MainPage },
  data() {
    return {
      loaded: false,
      genres: [],
      schools: []
    };
  },
  mounted() {
    this.setPageContext("jury", () => {
      this.loaded = true;
      this.fetchFilterData();
    });
  },
  methods: {
    async fetchFilterData() {
      this.genres = await this.fetchResource("Genre");
      this.schools = await this.fetchResource("School");
    },
  },
};
</script>

<style scoped lang="scss">
</style>
